import type { ReactNode } from "react";
import { Link } from "react-router";

/** Where an item may point: a path inside the portal, or an https address. Anything else is not drawn. */
export function ItemLink({
  url,
  className,
  onNavigate,
  children,
}: {
  url: string;
  className?: string;
  onNavigate?: () => void;
  children: ReactNode;
}) {
  if (url.startsWith("/") && !url.startsWith("//")) {
    return (
      <Link to={url} className={className} onClick={onNavigate}>
        {children}
      </Link>
    );
  }
  if (url.startsWith("https://")) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    );
  }
  return null;
}
